module.exports = __webpack_public_path__ + "c39a51eb654499e373f11fcc58776581.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Header/images/logo.png
// module id = dSCy
// module chunks = 0